
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/addPanelInfra/newAddPanel/sectionView.scss.css.virtualfile';
        module.exports = {"sectionView":"_sectionView_aff3l_1"};